const ReturnIcon = ({ className, isSelected = false, fillColor }) => {
  const defaultFillColor = fillColor || (isSelected ? 'var(--forbrand-primary)' : 'var(--forbrand-secondary)')

  return (
    <div
      className={`${className} flex items-center justify-center w-[32px] h-[32px]`}
    >
    <svg width="24" height="24" viewBox="0 0 24 24" fill={fillColor} xmlns="http://www.w3.org/2000/svg">
<path d="M6 21V3H12V9H18V19.5H19.5V7.56443L13.4356 1.5H4.5V22.5H18.4497L19.5 21H6ZM13.5 3.68558L17.3144 7.5H13.5V3.68558ZM13.6797 16.5L12.8137 18H7.5V16.5H13.6797ZM16.5 14.25H7.5V12.75H16.5V14.25Z" fill="#111113"/>
</svg>


    </div>
  )
}

export default ReturnIcon
